module.exports = __webpack_public_path__ + "static/media/notification-bell-icon.4297e8a5.svg";